import { Theme as RadixTheme } from '@radix-ui/themes'
import React from 'react'

export interface ThemeProviderProps {
  theme?: 'light' | 'dark'
  children: React.ReactNode
}

export const EpilotThemeProvider = ({
  theme = 'light',
  children
}: ThemeProviderProps) => {
  return (
    <RadixTheme
      accentColor="blue"
      appearance={theme}
      className={`epilot360-core-ui ${theme}-theme`}
      grayColor="gray"
    >
      {children}
    </RadixTheme>
  )
}
